import React from 'react';
import PropTypes from 'prop-types';

// Resource specific imports:
import ParticipantContainer from './components/ParticipantContainer';
import ProductContainer from './components/ProductContainer';
import Extras from './components/Extras';
import Schema from './components/Schema';
import ScheduleContainer from './components/ScheduleContainer';
import OptionalProductContainer from './components/OptionalProductContainer';
import Wrapper from './components/Wrapper';
import editMinutes from './components/editMinutes';
import BeforeOrAfterContainer from './components/BeforeOrAfterContainer';
import DatePicker from 'react-date-picker';
import {Card} from "../../styledComponents";
import Calendar from 'react-calendar';



class Resource extends React.Component {
    state = {
        participants: undefined, // Spara id/value eller motsvarande här
        product: undefined, // Spara id/SKU eller motsvarande här
        productContentSku: undefined,
        productName: undefined,
        productCost: undefined,
        duration: undefined,
        date: undefined,
        optionalProducts: [],
        beforeOrAfter: undefined,
        pickedDate: new Date(),
    };

    componentDidMount() {
        this.setState({participants: this.props.defaultParticipants});

        if (this.props.group) {
            this.props.handleMasterData(new Date());
        }

    }


    checkIfResourceComplete = () => {
        const {
            participants, product, productContentSku, duration, date,
        } = this.state;

        // Todo break out master in to own state in parent


        if (
            participants !== undefined &&
            product !== undefined &&
            productContentSku !== undefined &&
            duration !== undefined &&
            date !== undefined && Object.keys(date).length !== 0
        ) {
            const {id, master} = this.props;
            this.props.onComplete({
                id,
                ...this.state,
                master,
            });
        } else {
            // The product is not complete, remove it
            const {id} = this.props;

            this.props.inComplete({
                id,
            });
        }
    };

    handleParticipantClick = (participants) => {
        this.setState({participants}, this.checkIfResourceComplete);
    };

    handleProductClick = (product) => {
        this.setState({
            product: product.sku,
            productContentSku: product.contentSku,
            duration: product.duration,
            productName: product.name,
            productCost: product.cost,
        }, this.checkIfResourceComplete);
    };

    handleScheduleClick = (date) => {
        this.setState(
            {date: {...date}},
            this.checkIfResourceComplete,
        );
    };

    handleOptionalProductClick = (data) => {
        this.setState((prevState) => {
            const optionalProducts = [...prevState.optionalProducts];
            const findIndex = optionalProducts.findIndex(({sku}) => sku === data.sku);

            if (findIndex !== -1) {
                // om den finns, ta bort den.
                // optionalProducts[findIndex] = { ...data };
                const test = [...prevState.optionalProducts].filter(({sku}) => sku !== data.sku);


                return {optionalProducts: test};
            }
            optionalProducts.push(data);

            return {optionalProducts};
        }, this.checkIfResourceComplete);
    };

    handleBeforeOrAfter = (data) => {
        // remote this temporarly
        // this.setState({ beforeOrAfter: data });
    };

    handlePickedDate = (m) => {
        const pickedDate = new Date(m.getTime() - (m.getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
        this.setState({pickedDate});
    };

    // Todo: build something this should send up to App

    render() {
        const {
            id, participants, products, optionalProducts, extras,
            schedule, schema, lang, master, bookingData, showBeforeOrAfter, refreshSchedule, resourceName, group,
            handleMasterData,
        } = this.props;


        const {
            participants: stateParticipants,
            product: stateProduct,
            date: stateDate,
            optionalProducts: stateOptionalProducts,
            productContentSku,
            duration,
            beforeOrAfter,
            productCost,
            pickedDate,
        } = this.state;

        let { masterData } = this.props;

        if (masterData !== undefined && masterData.id === id) {
            masterData = undefined;
        }

        const style = {
            margin: '0 auto',
            width: '300px'
    }

        if (group) {
            return (
                <React.Fragment>
                <Card
                title={lang.schedule.pickDate}
                >
                    <div
                    style={style}>
                        <Calendar
                            minDate={new Date()}
                            maxDate={new Date(new Date().setMonth(new Date().getMonth() + 11))}
                            locale={lang.schedule.locale}
                            onChange={(m) => handleMasterData(m)}
                            value={new Date(pickedDate)}
                        />
                    </div>
                </Card>
                    <br/>
                </React.Fragment>
            )
        }


        return (
            <Wrapper
                master={master}
                showBeforeOrAfter={showBeforeOrAfter}
                resourceName={resourceName}
                onClickSchedule={this.handleScheduleClick}
                masterData={masterData}
                lang={lang}
            >
                <ParticipantContainer
                    items={participants.items}
                    settings={participants.settings}
                    lang={lang.participants}
                    onClickParticipant={this.handleParticipantClick}
                    activeParticipant={stateParticipants}
                />
                <ProductContainer
                    items={products.items}
                    settings={products.settings}
                    lang={lang.products}
                    onClickProduct={this.handleProductClick}
                    activeParticipant={stateParticipants}
                    activeProduct={stateProduct}
                    master={master}
                />


                {(master || showBeforeOrAfter === false) && (
                    <ScheduleContainer
                        id={id}
                        items={schedule}
                        lang={lang.schedule}
                        onClickSchedule={this.handleScheduleClick}
                        activeDate={stateDate}
                        activeProduct={productContentSku}
                        duration={duration}
                        activeParticipants={stateParticipants}
                        refreshSchedule={refreshSchedule}
                        masterData={masterData}
                        bookingData={bookingData}
                    />
                )}

                {master === false && showBeforeOrAfter && (

                    <BeforeOrAfterContainer
                        masterData={masterData}
                        bookingData={bookingData}
                        onClickSchedule={this.handleScheduleClick}
                        duration={duration}
                        beforeOrAfter={beforeOrAfter}
                        handleBeforeOrAfter={this.handleBeforeOrAfter}

                    />


                )}

                {optionalProducts.length !== 0 && (
                    <OptionalProductContainer
                        items={optionalProducts}
                        settings={products.settings}
                        activeOptionalProducts={stateOptionalProducts}
                        onClickProduct={this.handleOptionalProductClick}
                        activeParticipant={stateParticipants}
                        activeProduct={stateProduct}
                        activeProductCost={productCost}
                    />
                )}
            </Wrapper>
        );
    }
}

Resource.propTypes = {
    id: PropTypes.string.isRequired,
    participants: PropTypes.array.isRequired,
    products: PropTypes.array.isRequired,
    extras: PropTypes.array.isRequired,
    schedule: PropTypes.object.isRequired,

    defaultParticipants: PropTypes.number.isRequired,

    //
    onComplete: PropTypes.func.isRequired,
    inComplete: PropTypes.func.isRequired,

};

export default Resource;



// WEBPACK FOOTER //
// ./src/components/Resource/index.js